module.exports = __webpack_public_path__ + "img/product_not_found.d28ee639.jpg";